<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    @for (coordAndContent of state().getCoordsAndContents(); track coordAndContent.coord.toString()) {
        <g id="click-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
           [attr.transform]="getHexaCenterTranslationAt(coordAndContent.coord)"
           (click)="onClick(coordAndContent.coord)">
            @if (coordAndContent.content.isReachable()) {
                <polygon id="space-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                         [attr.points]="getHexaPoints()"
                         [ngClass]="getPlayerClassAt(coordAndContent.coord)"
                         class="base mid-stroke"/>
            }
            @if (coordAndContent.content.isDead()) {
                <g id="dead-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}">
                    <polygon [attr.points]="getHexaDiagonalPoints()"
                             class="base no-fill captured-stroke"/>
                    />
                </g>
            }
            @if (coordAndContent.content.isTerritory()) {
                <polygon id="territory-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                         [attr.points]="getHexaPoints()"
                         [attr.transform]="getTerritoryHexagonalTransform()"
                         [ngClass]="getPlayerClass(coordAndContent.content.player)"/>
            }
        </g>
    }

    @if (last.isPresent() && state().isOnBoard(last.get())) {
        <polygon id="last-{{ last.get().x }}-{{ last.get().y }}"
                 [attr.transform]="getHexaCenterTranslationAt(last.get())"
                 [attr.points]="getHexaPoints()"
                 [ngClass]="getPlayerClassAt(last.get())"
                 class="last-move-stroke big-stroke no-fill"/>
    }

</svg>
